import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class MaterialsTagsApi extends ApiModule {
	constructor() {
		super(ModulesMap.MATERIALS_TAGS, {
			entity: 'materials_tags',
		})
	}
}
